export const legacyAdminActMap: Record<string, string> = {
  'admin_orders_list': 'ops.transactions.list',
  'admin_recent_transactions': 'activity.recent.transactions',
  'admin_recent_payouts': 'activity.recent.transactions',
  'admin_activity_metrics': 'dashboard.totals',
  'admin_recent_webhooks': 'webhooks.recent',
  'admin_recent_email_queue': 'activity.recent.emails',
  'admin_recent_onboarding_events': 'activity.recent.transactions',
  'admin_list_webhook_events_with_audit_v1': 'webhooks.recent',
  'admin_webhook_security_summary': 'webhooks.security.summary',
  'admin_webhooks_stats': 'webhooks.stats',
  'admin_bridge_webhook_replay_v1': 'ops.webhooks.replay',
  'admin_pending_operations_alerts': 'diagnostics.snapshot',
  'admin_get_system_metrics': 'observability.metrics.synthetic',
  'admin_list_alert_rules': 'observability.alertRules.synthetic',
  'get_system_health_metrics': 'dashboard.totals',
  'get_onboarding_health_metrics_safe': 'dashboard.totals',
  'admin_list_customers_unified': 'customers.list',
  'admin_unified_customers_list': 'customers.list',
  'admin_people_count': 'customers.count',
  'get_user_bank_accounts': 'wallet.externalAccounts.list',
  'bridge-sync-customers': 'bridge.sync-customers',
  'bridge-sync-kyc-status': 'bridge.sync-kycStatus',
} as const;

export const resolveLegacyAdminAct = (name: string): string | null =>
  legacyAdminActMap[name] ?? null;
